/* RO product state machine.
   Resolves the variant from option radios, keeps price / availability /
   selling-plan input / sticky bar in sync — no page reloads. */
(function () {
  'use strict';

  function money(cents) {
    var d = cents / 100;
    return d % 1 === 0 ? '$' + d.toFixed(0) : '$' + d.toFixed(2);
  }

  function init(root) {
    var dataEl = root.querySelector('[data-ro-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var hasPlans = root.getAttribute('data-has-plans') === 'true';

    var variantInput = root.querySelector('[data-ro-variant-id]');
    var planInput = root.querySelector('[data-ro-selling-plan]');
    var planSelect = root.querySelector('[data-ro-plan-select]');
    var typeRadios = root.querySelectorAll('input[name="ro_purchase_type"]');
    var optionSets = root.querySelectorAll('.ro-opt[data-option-position]');
    var atc = root.querySelector('[data-ro-atc]');
    var atcLabel = root.querySelector('[data-ro-atc-label]');
    var atcPrice = root.querySelector('[data-ro-atc-price]');
    var planPrice = root.querySelector('[data-ro-plan-price]');
    var onetimePrice = root.querySelector('[data-ro-onetime-price]');
    var qtyInput = root.querySelector('[data-ro-qty]');
    var stockLine = root.querySelector('[data-ro-stock]');

    function selectedOptions() {
      var opts = [];
      optionSets.forEach(function (set) {
        var pos = parseInt(set.getAttribute('data-option-position'), 10);
        var checked = set.querySelector('input:checked');
        opts[pos - 1] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (val, i) {
          return opts[i] === null || opts[i] === undefined || val === opts[i];
        });
      });
    }

    function purchaseType() {
      var checked = root.querySelector('input[name="ro_purchase_type"]:checked');
      return checked ? checked.value : 'one-time';
    }

    function currentAllocation(variant) {
      if (!hasPlans || !variant || !variant.allocations.length) return null;
      var planId = planSelect ? parseInt(planSelect.value, 10) : null;
      return variant.allocations.find(function (a) { return a.plan_id === planId; }) || variant.allocations[0];
    }

    function markAvailability(opts) {
      optionSets.forEach(function (set) {
        var pos = parseInt(set.getAttribute('data-option-position'), 10);
        set.querySelectorAll('label').forEach(function (label) {
          var input = label.querySelector('input');
          if (!input) return;
          var test = opts.slice();
          test[pos - 1] = input.value;
          var v = findVariant(test);
          label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    /* Pills must quote the price the shopper will actually pay, which is the
       club price whenever the club option is selected (and it is by default). */
    function sizePills(opts, subscribing) {
      root.querySelectorAll('[data-size-price]').forEach(function (el) {
        var test = opts.slice();
        var sizeSet = root.querySelector('.ro-opt--size');
        if (!sizeSet) return;
        var pos = parseInt(sizeSet.getAttribute('data-option-position'), 10);
        test[pos - 1] = el.getAttribute('data-size-price');
        var v = findVariant(test);
        if (!v) return;
        var alloc = subscribing ? currentAllocation(v) : null;
        el.textContent = money(alloc ? alloc.price : v.price);
      });
    }

    function sync() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      var type = purchaseType();
      var subscribing = hasPlans && type === 'subscribe';

      /* Clamp AND write back: computing a display-only value let a typed 0 keep
         the button enabled at a 1-unit price while adding nothing to the cart,
         and let a typed 99 bypass the field's own max. */
      var qty = 1;
      if (qtyInput) {
        var max = parseInt(qtyInput.max, 10) || 20;
        var min = parseInt(qtyInput.min, 10) || 1;
        qty = Math.min(max, Math.max(min, parseInt(qtyInput.value, 10) || min));
        if (String(qty) !== qtyInput.value) qtyInput.value = qty;
      }

      markAvailability(opts);
      sizePills(opts, subscribing);

      if (!variant) {
        if (atc) { atc.disabled = true; }
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        if (atcPrice) atcPrice.textContent = '';
        return;
      }

      variantInput.value = variant.id;

      var alloc = currentAllocation(variant);
      var unit = subscribing && alloc ? alloc.price : variant.price;

      if (planInput) {
        if (subscribing && alloc) {
          planInput.value = alloc.plan_id;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
      if (planPrice && alloc) planPrice.textContent = money(alloc.price);
      if (onetimePrice) onetimePrice.textContent = money(variant.price);

      if (atc) atc.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (atcPrice) atcPrice.textContent = variant.available ? money(unit * qty) : '';

      /* In-stock carries no colour class — availability is not a sanctioned
         green role, and a green span would tint the ● glyph as well. It
         inherits --ro-mute from .ro-pdp__stock. This string must stay
         identical to the server-rendered one in ro-main-product.liquid. */
      if (stockLine) {
        stockLine.innerHTML = variant.available
          ? '● In stock — roasted to order, ships in 3–5 days'
          : '<span class="ro-pdp__oos">Currently out of stock</span>';
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      document.dispatchEvent(new CustomEvent('ro:variant-change', {
        detail: {
          variant: variant,
          unitPrice: unit,
          subscribing: subscribing,
          quantity: qty,
          available: variant.available
        }
      }));
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select, [data-ro-qty]')) sync();
    });

    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      sync();
    });
    if (plus) plus.addEventListener('click', function () {
      qtyInput.value = Math.min(20, (parseInt(qtyInput.value, 10) || 1) + 1);
      sync();
    });

    /* Gallery thumbs */
    root.querySelectorAll('[data-thumb-index]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-thumb-index');
        root.querySelectorAll('.ro-pdp__image').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-index') === idx);
        });
        root.querySelectorAll('[data-thumb-index]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    sync();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ro-product]').forEach(init);
  });
})();
